export const convertEvoGetPrizes = (evoPrizes) => {
    var _a;
    const { data, meta } = evoPrizes;
    const convertedPrizes = data === null || data === void 0 ? void 0 : data.map((prize) => {
        const { presentation: { images = [], name, description }, identifier: prize_uuid, brand_name: brandName, points, custom_attributes: { color, locations = [] }, has_coupons, created_at, levels, } = prize;
        return {
            prize_uuid,
            name,
            brandName,
            subtitle: description !== null && description !== void 0 ? description : "",
            points,
            images,
            color: color !== null && color !== void 0 ? color : "",
            has_coupons,
            created_at,
            levels: levels !== null && levels !== void 0 ? levels : [],
            locations,
        };
    });
    return {
        items: convertedPrizes,
        total: (_a = meta.total) !== null && _a !== void 0 ? _a : 0,
    };
};
//# sourceMappingURL=convertEvoGetPrizes.js.map